import { useSyncExternalStore } from "react";
import { basketStore, type BasketItem } from "../stores/basket-store";

// The school's basket as the overlays read it, kept current as it changes
// (this page, or another tab). One subscription shape for every overlay.

const subscribe = (onChange: () => void) => {
  const unsubscribe = basketStore.subscribe(onChange);
  return () => {
    unsubscribe();
  };
};

/** The school's basket lines. */
export function useBasketItems(businessId: string): BasketItem[] {
  return useSyncExternalStore(
    subscribe,
    () => basketStore.getItems(businessId),
    () => basketStore.getItems(businessId),
  );
}

/** How many things the school's basket holds (`countBasketItems`: the rule
 *  the basket's own button and Website v2's navbar count by). */
export function useBasketItemCount(businessId: string): number {
  return useSyncExternalStore(
    subscribe,
    () => basketStore.getItemCount(businessId),
    () => 0,
  );
}
